angular.module('rallly')
.controller('AccountCtrl', function($scope, ConfirmModal){
    $scope.showNotice = function(){
        
    }
})
